import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  Button,
  IconButton,
  DialogActions,
  TextField,
  Dialog,
  useTheme,
  useMediaQuery,
  Box,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import SnackBarUtils from '../../utils/SnackBarUtils'
import { crearObservacion } from './services/admin.local.services'
import { TenantsContext } from '../../context/tenants.context'

interface CrearObsevacionProps {
  open: boolean
  setOpen: (open: boolean) => void
  idLocal: number
  loading: boolean
  setLoading: (loading: boolean) => void
  updateLocal: (id: any) => void
}

export const MAX_OBS_LENGTH = 1000

const CrearObsevacion: React.FC<CrearObsevacionProps> = ({
  open,
  setOpen,
  idLocal,
  loading,
  setLoading,
  updateLocal
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [observaciones, setObservaciones] = useState<string>('')
  const [error, setError] = useState<{ err: boolean; msj: string }>({ err: false, msj: '' })
  const { tenant } = useContext(TenantsContext)

  const handleCrearObsevacion = useCallback(async () => {
    if (observaciones === '') return setError({ err: true, msj: 'No puede mandar una observación vacía' })
    try {
      setLoading(true)
      await crearObservacion(tenant, idLocal, observaciones).then((data) => {
        SnackBarUtils.success('Observación publicada correctamente')
        updateLocal(idLocal)
      })
    } catch (error) {
      SnackBarUtils.error('Error al crear observación')
      console.log(error)
    } finally {
      setLoading(false)
      handleClose()
    }
  }, [idLocal, observaciones])

  const handleClose = () => {
    setOpen(false)
    setObservaciones('')
    setError({ err: false, msj: '' })
  }

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        PaperProps={{
          style: {
            display: 'flex',
            padding: '20px 20px 10px 20px',
            overflow: 'hidden'
          }
        }}
        onClose={handleClose}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="h5"
            sx={{
              textAlign: 'center',
              fontWeight: 'bold'
            }}
          >
            Nueva Observación
          </Typography>
        </Box>
        <Typography variant="subtitle2" style={{ display: 'flex', justifyContent: 'end' }}>
          {observaciones?.length || 0}/{MAX_OBS_LENGTH}
        </Typography>
        <TextField
          disabled={loading}
          label=""
          multiline
          rows={4}
          fullWidth
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          sx={{ marginTop: '10px' }}
          error={error.err}
          helperText={error.err && error.msj}
          inputProps={{ maxLength: MAX_OBS_LENGTH }}
        />
        <Button
          disabled={loading}
          variant="contained"
          onClick={handleCrearObsevacion}
          color="success"
          sx={{ marginTop: '20px', width: '100%' }}
        >
          Crear
        </Button>
        <DialogActions>
          <IconButton
            disabled={loading}
            edge="end"
            onClick={handleClose}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '16px'
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default CrearObsevacion
